<app-ice-stepper
  #stepper
  [hasCustomNavigation]="false"
  [interactedSteps]="interactedSteps() || []"
  [selectedIndex]="selectedStep() || 0"
  (isFinished)="submitClicked.emit()"
  (selectionChange)="onStepperChange($event)"
>
  @if (tradeInForm) {
    <form ngxsForm="formState.tradeInForm" [formGroup]="tradeInForm">
      <cdk-step label="Betingelser" [completed]="true">
        <app-trade-in-terms />
        <div class="step-navigation">
          <app-ice-button color="secondary" testId="trade-in-next-button" (click)="stepper.next()">Fortsett</app-ice-button>
        </div>
      </cdk-step>
      <cdk-step label="Spesifikasjoner" [completed]="specificationsForm.valid" [hasError]="showSpecificationsFormError">
        <app-trade-in-specifications
          [tradeInSpecificationsForm]="specificationsForm"
          (infoClicked)="infoClicked.emit($event)"
        />
        <div class="step-navigation">
          <app-ice-button color="outlined" testId="trade-in-back-button" (click)="stepper.previous()">
            Tilbake
          </app-ice-button>
          <app-ice-button color="secondary" testId="trade-in-next-button" (click)="stepper.next()">Fortsett</app-ice-button>
        </div>
      </cdk-step>
      <cdk-step label="Tilstand" [completed]="conditionForm.valid" [hasError]="showConditionsFormError">
        @if (conditionFormControlCount > 0) {
          <app-trade-in-condition [tradeInConditionForm]="conditionForm" (infoClicked)="infoClicked.emit($event)" />
        } @else {
          <app-spinner class="spinner" />
        }
        <div class="step-navigation">
          <app-ice-button color="outlined" testId="trade-in-back-button" (click)="stepper.previous()">
            Tilbake
          </app-ice-button>
          <app-ice-button color="secondary" testId="trade-in-next-button" (click)="stepper.next()">Neste</app-ice-button>
        </div>
      </cdk-step>
      <cdk-step label="Oppsummering" [completed]="true">
        <app-trade-in-summary />
        <div class="step-navigation">
          <app-ice-button color="outlined" testId="trade-in-back-button" (click)="stepper.previous()">
            Tilbake
          </app-ice-button>
          <app-ice-button
            color="primary"
            testId="trade-in-finished-button"
            [disabled]="tradeInForm.invalid || tradeInForm.disabled"
            (click)="submitClicked.emit()"
          >
            Beregn takst
          </app-ice-button>
        </div>
      </cdk-step>
    </form>
  }
</app-ice-stepper>
